import { memo, useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import "./pagination.scss";

const CustomPagination = memo(
  ({ activePage, onPageChange, pageLength, totalData, lastPage, small }) => {
    const pageCount = lastPage;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const TotalItemsInfo = () => (
      <div className="text-muted small mb-1 text-center" style={{ marginTop: "25px !important" }}>
        Total Items: {totalData}
      </div>
    );

    return (
      <>
        {small || isMobile ? (
          <div
            className="pagination d-flex flex-column align-items-center"
            style={{ margin: "0 auto", marginTop: "25px !important" }}
          >
            <TotalItemsInfo />
            <Pagination
              className="justify-content-center align-items-center mobile-pagination"
              style={{ gap: "4px" }}
            >
              <Pagination.Prev
                disabled={activePage === 1}
                onClick={() => onPageChange(activePage - 1)}
              >
                {"< Prev"}
              </Pagination.Prev>

              <div className="pagination_numbers d-flex align-items-center">
                {pageCount <= 3 ? (
                  Array.from({ length: pageCount }).map((_, index) => (
                    <Pagination.Item
                      key={index}
                      active={index + 1 === activePage}
                      onClick={() => onPageChange(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))
                ) : (
                  <>
                    <Pagination.Item onClick={() => onPageChange(1)} active={activePage === 1}>
                      1
                    </Pagination.Item>

                    {activePage > 2 && <Pagination.Ellipsis disabled />}

                    {activePage !== 1 && activePage !== pageCount && (
                      <Pagination.Item active>{activePage}</Pagination.Item>
                    )}

                    {activePage < pageCount - 1 && <Pagination.Ellipsis disabled />}

                    {pageCount > 1 && (
                      <Pagination.Item
                        onClick={() => onPageChange(pageCount)}
                        active={activePage === pageCount}
                      >
                        {pageCount}
                      </Pagination.Item>
                    )}
                  </>
                )}
              </div>

              <Pagination.Next
                disabled={activePage === pageCount}
                onClick={() => onPageChange(activePage + 1)}
              >
                {"Next >"}
              </Pagination.Next>
            </Pagination>
          </div>
        ) : (
          <div
            className="pagination d-flex flex-column align-items-center"
            style={{ margin: "0 auto", marginTop: "25px !important" }}
          >
            <TotalItemsInfo />
            <Pagination className="justify-content-between w-100 px-4 align-items-center desktop-pagination">
              <Pagination.Prev
                disabled={activePage === 1}
                onClick={() => onPageChange(activePage - 1)}
              >
                &#x3c; Prev
              </Pagination.Prev>

              <div className="pagination_numbers d-flex align-items-center">
                {pageCount <= 8 ? (
                  Array.from({ length: pageCount }).map((_, index) => (
                    <Pagination.Item
                      key={index}
                      active={index + 1 === activePage}
                      onClick={() => onPageChange(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))
                ) : (
                  <>
                    {activePage > 4 && (
                      <>
                        <Pagination.Item onClick={() => onPageChange(1)}>{1}</Pagination.Item>
                        <Pagination.Ellipsis disabled />
                      </>
                    )}

                    {Array.from({ length: pageCount }).map((_, index) => {
                      if (
                        index === activePage - 2 ||
                        index === activePage - 1 ||
                        index === activePage ||
                        index === activePage + 1 ||
                        index === activePage + 2
                      ) {
                        return (
                          <Pagination.Item
                            key={index}
                            active={index + 1 === activePage}
                            onClick={() => onPageChange(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        );
                      }
                      return null;
                    })}

                    {activePage < pageCount - 2 && (
                      <>
                        <Pagination.Ellipsis disabled />
                        <Pagination.Item onClick={() => onPageChange(pageCount)}>
                          {pageCount}
                        </Pagination.Item>
                      </>
                    )}
                  </>
                )}
              </div>

              <Pagination.Next
                disabled={activePage === pageCount}
                onClick={() => onPageChange(activePage + 1)}
              >
                Next &#x3e;
              </Pagination.Next>
            </Pagination>
          </div>
        )}
      </>
    );
  },
);

export default CustomPagination;
